/* Sticky purchase bar — show on 15% scroll, hide if back to <12%
   (hysteresis prevents flicker around the threshold). CTA smooth-
   scrolls to #nb-bundle-anchor (the bundle picker) so the user
   lands on the actual decision surface, not the page top. */
(function () {
  'use strict';

  function init() {
    var bar = document.getElementById('nb-sticky-cta');
    if (!bar) return;

    var shown = false;

    function checkScroll() {
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight <= 0) return;
      var scrolled = window.scrollY / docHeight;

      if (scrolled >= 0.15 && !shown) {
        bar.classList.add('nb-visible');
        shown = true;
      } else if (scrolled < 0.12 && shown) {
        bar.classList.remove('nb-visible');
        shown = false;
      }
    }

    window.addEventListener('scroll', checkScroll, { passive: true });
    checkScroll();

    /* CTA — smooth-scroll to the bundle picker. Native anchor
       jump would land at the top of the section without easing. */
    var btn = bar.querySelector('[data-nb-sticky-cta-btn]');
    if (btn) {
      btn.addEventListener('click', function (e) {
        var target = document.getElementById('nb-bundle-anchor');
        if (!target) return; /* let the default anchor jump fire */
        e.preventDefault();
        var offset = 72; /* room for the sticky bar itself */
        var rect = target.getBoundingClientRect();
        var top = rect.top + window.scrollY - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    }

    /* Estimated ship date — 5 business days from now. */
    var shipEl = bar.querySelector('[data-nb-sticky-ship-date]');
    if (shipEl) {
      var d = new Date();
      var businessDays = 5;
      var count = 0;
      while (count < businessDays) {
        d.setDate(d.getDate() + 1);
        var day = d.getDay();
        if (day !== 0 && day !== 6) count++;
      }
      var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      var days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
      shipEl.textContent = days[d.getDay()] + ', ' + months[d.getMonth()] + ' ' + d.getDate();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
